import { Component, OnInit, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ActionsService, UserService } from '@app/core/services';

@Component({
  selector: 'howden-sucess',
  templateUrl: './sucess.component.html',
  styleUrls: ['./sucess.component.scss'],
  imports: [MatButton]
})
export class SucessComponent implements OnInit {
  private usrSrv = inject(UserService);
  private actionsSrv = inject(ActionsService);

  ngOnInit(): void {
    this.actionsSrv.hideLoading();
  }

  goCallBack() {
    if (this.usrSrv.validCallBack) {
      window.location.href = this.usrSrv.callBackStr;
    }
  }

  get validUrl(): boolean {
    return this.usrSrv.validCallBack;
  }
}
